// The User model has weird casing because it matches the casing returned by
// server.

export type Session = {
	user: User,
}

export type User = ParcialUser & {
	organizations: (Organization & {
		// This array of organizations is from the perspective of the user and
		// therefore does not have its own external type.
		role: OrganizationMemberRole,
	})[],
}

export type ParcialUser = {
	user_id: string,
	email: string
	given_name: string,
	middle_names: string,
	family_name: string,
}

export enum OrganizationMemberRole {
	Regular = 20,
	Admin = 80,
}

export type UserHealth = {
	user_id: string,
	last_app_activity: string | undefined,
}

export type Organization = {
	organization_id: string,
	name: string,
}

export type AlarmGroup = {
	alarm_group_id: string,
	organization_id: string,
	template: AlarmTemplate,
	created_at: string,
	members: ParcialUser[],
	members_health: UserHealth[],
	assignableUsers: ParcialUser[],
}

export type AlarmTemplate = {
	// We don't care about appearance_ios, so not included.
	localized: { [K in string]: AlarmTemplateLocalized },
}

export type AlarmTemplateLocalized = {
	title: string,

	// We don't care about manual sections, so not included.
}

export type AlarmGroupMember = {
	alarm_group_id: string,
	user_id: string,
}

export type UserSpecifier = Pick<ParcialUser, "user_id">

export type GuardedRequestInfo = {
	status: "VALID" | "EXPIRED"
}

export type AccountCreationRequestInfo = GuardedRequestInfo & {
	email: string,
}
